<template>
  <v-form ref="listMachineMaintenanceForm">
    <v-container>
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="pb-0">
          <div class="d-flex" v-if="filterBadge.length > 0">
            <v-chip small class="mr-2" v-for="(text, index) in filterBadge" :key="index">{{text}}</v-chip>
          </div>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" :class="[$vuetify.breakpoint.mdAndDown ? 'text-left' : 'text-right']">
          <v-btn v-if="$checkRight(['edit_machine_maintenance'])" :to="'machineMaintenance/create'" class="primary" small>Add</v-btn>
          <v-btn @click="openDrawer = !openDrawer" class="ml-2" small color="#eee">
            <v-icon small>mdi-filter</v-icon>
          </v-btn>
          <v-btn @click="deactiveMachineMaintenance" class="ml-2" small color="#eee" v-if="$checkRight(['edit_machine_maintenance'])">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="clearFilter(false);$refreshDataTable()" class="ml-2" small color="#eee">
              <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Datatable -->
      <datatable
        ref="machine_maintenance_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
        :filterColumn="filterColumn"
      />
      <!-- Filter -->
      <popup-drawer :value.sync="openDrawer" :openDrawer="openDrawer">
        <v-col cols="12">
          <searchable-select ref="filterMachineMaintenanceId" :value.sync="filter.machine_id" :options="{ url: 'machine', label: 'Machine', returnType: 'object'}"/>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.schedule_date_from_date"
            type="date"
            placeholder="From Schedule Date"
            label="From Schedule Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.schedule_date_to_date"
            type="date"
            placeholder="To Schedule Date"
            label="To Schedule Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.completed_date_from_date"
            type="date"
            placeholder="From Completed Date"
            label="From Completed Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.completed_date_to_date"
            type="date"
            placeholder="To Completed Date"
            label="To Completed Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="Cost"
            label="Cost"
            v-model="filter.cost"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Is Break Down"
            placeholder="Is Break Down"
            v-model="filter.is_break_down"
            :items="[{id: 0, text: 'No', color: 'warning'}, {id: 1, text: 'Yes', color: 'green'}]"
            :small-chips="true">
            <template #selection="{ item }">
              <v-chip :color="item.color" small>{{item.text}}</v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Status"
            placeholder="Status"
            v-model="filter.status"
            :items="[{id: 0, text: 'Active', color: 'success'}, {id: 1, text: 'Inactive', color: 'warning'}]"
            :small-chips="true">
            <template #selection="{ item }">
              <v-chip :color="item.color" small>{{item.text}}</v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn @click="filterData" class="mt-4" color="primary" small>Filter</v-btn>
          <v-btn @click="clearFilter" class="mt-4 ml-2" small>Clear</v-btn>
        </v-col>
      </popup-drawer>
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  computed: {
    filterBadge () {
      const fList = []
      Object.keys(this.filterDisplay).map((x, i) => {
        if (typeof this.filterDisplay[x] === 'object') {
          fList.push(this.filterDisplay[x].text)
        } else if (this.filterDisplay[x]) {
          fList.push(this.filterDisplay[x])
        }
      })
      return fList
    }
  },
  created () {
    if (!this.$checkRight(['edit_machine_maintenance'])) {
      this.tableOption.headers.shift()
    }
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getMachineMaintenanceAll',
        editUrl: 'machineMaintenance/edit',
        deleteRoute: 'deactiveMachineMaintenance',
        moduleName: 'machineMaintenance',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Machine', value: 'machine_name' },
          { text: 'Schedule Date', value: 'schedule_date' },
          { text: 'Completed Date', value: 'completed_date' },
          { text: 'Cost', value: 'cost' },
          { text: 'Is Break Down', value: 'is_break_down' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        },
        is_break_down: {
          0: { color: 'orange', text: 'No' },
          1: { color: 'green', text: 'Yes' }
        }
      },
      filterColumn: {
        schedule_date: { format: '' },
        completed_date: { format: '' },
      },
      openDrawer: false,
      filter: {},
      filterDisplay: {}
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveMachineMaintenance () {
      this.$refs.machine_maintenance_datatable.massDeleteTableData()
    },
    filterData () {
      this.$eventBus.$emit('$filterDataTable', this.filter)
      this.openDrawer = false
      this.filterDisplay = this.filter ? JSON.parse(JSON.stringify(this.filter)) : {}
    },
    clearFilter (callEmit = true) {
      if (callEmit) {
        this.$eventBus.$emit('$filterDataTable', {})
      }
      this.openDrawer = false
      this.filter = {}
      this.filterDisplay = {}
      this.$refs.filterMachineMaintenanceId.selected = []
    }
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
